<template>
    <div>
        <div
            v-if="config.public.website !== 'cromi.ru'"
            class="flex items-center justify-center space-x-10 max-md:my-5 md:justify-end">
            <BuroIcon class="h-auto max-w-[87px]" />
            <NAOMIcon class="h-auto max-w-[87px]" />
        </div>
        <div class="flex items-center justify-start">
            <SpbIcon class="size-11 shrink-0 md:size-16" />
            <NuxtLink
                to="http://spbtpp.ru/arenda-i-prodazha-turgidov-audiogidov-i-oborudovaniya-dlya-sinhronnogo-perevoda/"
                target="_blank"
                class="ml-3 text-9/160 font-semibold text-white">
                САНКТ-ПЕТЕРБУРГСКАЯ ТОРГОВО&#8209;ПРОМЫШЛЕННАЯ&nbsp;ПАЛАТА<br />
                SAINT-PETERSBURG CHAMBER OF&nbsp;COMMERCE AND INDUSTRY
            </NuxtLink>
        </div>
        <div
            class="mt-5 flex items-center justify-between space-x-2 md:space-x-5">
            <SberIcon class="h-auto w-[4.25rem] md:w-[4.75rem]" />
            <FabrikantIcon class="h-auto w-[5.5rem] md:w-[6rem]" />
            <TenderRTSIcon class="size-6" />
            <Roseltorgcon class="h-auto w-[5.5rem] md:w-[5.75rem]" />
        </div>
        <div
            class="mt-3 flex items-center justify-between space-x-2 md:space-x-5">
            <EisZakupkiIcon class="h-auto w-[4.75rem] md:w-[5.25rem]" />
            <TekTorgIcon class="h-auto w-[3.5rem] md:w-[4rem]" />
            <EtpGpbIcon class="h-auto w-[3.75rem] md:w-[4rem]" />
            <PortalPostavshikov class="h-auto w-[4.5rem] md:w-[4.75rem]" />
        </div>
    </div>
</template>

<script setup lang="ts">
import BuroIcon from '~/components/layouts/footer/svg/BuroIcon.vue'
import EisZakupkiIcon from '~/components/layouts/footer/svg/EisZakupkiIcon.vue'
import EtpGpbIcon from '~/components/layouts/footer/svg/EtpGpbIcon.vue'
import FabrikantIcon from '~/components/layouts/footer/svg/FabrikantIcon.vue'
import NAOMIcon from '~/components/layouts/footer/svg/NAOMIcon.vue'
import PortalPostavshikov from '~/components/layouts/footer/svg/PortalPostavshikov.vue'
import Roseltorgcon from '~/components/layouts/footer/svg/Roseltorgcon.vue'
import SberIcon from '~/components/layouts/footer/svg/SberIcon.vue'
import SpbIcon from '~/components/layouts/footer/svg/SpbIcon.vue'
import TekTorgIcon from '~/components/layouts/footer/svg/TekTorgIcon.vue'
import TenderRTSIcon from '~/components/layouts/footer/svg/TenderRTSIcon.vue'

const config = useRuntimeConfig()
</script>
